import styled, { css } from "styled-components"

export const SearchViewToggle = styled.div`
    margin-right: 10px;
`

export const SearchActionButtons = styled.div`
    display: flex;
    background-color: white;
    align-items: center;
    justify-content: space-between;
    margin-left: 10px;
    padding-bottom: ${({ isProfile }) => (isProfile ? "12px" : "13px")};
    // TODO: refactor sticky to instead use display: flex; flex-direction: column;
    // then set overflow: auto; on the "list-view list-view-results" child
    position: sticky;
    top: 0;
    // this needs to be 1001 because the z-index of dropdowns which exist in card options is 1000
    z-index: 3;
    // adding this padding so when we click on any children button and the border grows it is not cut off
    padding-top: 2px;
`

export const SearchActionButtonsLeftChildren = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
`

export const SearchActionButtonsRightChildren = styled.div`
    display: flex;
    align-items: center;
    ${({ isProfile }) =>
        isProfile &&
        css`
            margin-right: 10px;
        `}

    ${({ isProfile }) =>
        !isProfile &&
        css`
            min-width: 0;
        `}
`

export const SearchActionButtonsMiddleChildren = styled.div`
    display: flex;
    align-items: center;
`
